export const HOSPITALIZATION_INSTRUCTION_ID = 'hospitalization';

export const HOSPITALIZATION_CATEGORY = 'hospitalization';

export const HOSPITALIZATION_TITLE = 'Hospitalization';

export const HOSPITALIZATION_PROSE =
  'This patient is being admitted to the hospital. Home discharge instructions do not apply.';

export function createHospitalizationInstruction() {
  return {
    id: HOSPITALIZATION_INSTRUCTION_ID,
    title: HOSPITALIZATION_TITLE,
    category: HOSPITALIZATION_CATEGORY,
    prose: HOSPITALIZATION_PROSE,
    dependsOn: [],
    includedByDefault: false,
  };
}

export function isHospitalizationInstruction(instruction) {
  if (!instruction) return false;
  return (
    instruction.id === HOSPITALIZATION_INSTRUCTION_ID ||
    instruction.category === HOSPITALIZATION_CATEGORY
  );
}

export function hospitalizationIsSelected(includedIds, instructions = []) {
  if (includedIds?.has?.(HOSPITALIZATION_INSTRUCTION_ID)) return true;
  const list = Array.isArray(instructions) ? instructions : [];
  return list.some(
    (row) =>
      isHospitalizationInstruction(row) && includedIds?.has?.(row.id),
  );
}

export function ensureHospitalizationInstruction(instructions) {
  const list = (Array.isArray(instructions) ? instructions : []).filter(Boolean);
  const existing = list.find(isHospitalizationInstruction);
  const rest = list.filter((row) => !isHospitalizationInstruction(row));
  return [existing || createHospitalizationInstruction(), ...rest];
}

export function keepOnlyHospitalization(instructions) {
  const [hospitalization] = ensureHospitalizationInstruction(instructions);
  return [hospitalization];
}

export function collapseIfHospitalizationSelected(instructions, includedIds) {
  const ids = includedIds instanceof Set ? includedIds : new Set(includedIds || []);
  const list = ensureHospitalizationInstruction(instructions);
  if (!hospitalizationIsSelected(ids, list)) {
    return {
      instructions: list,
      includedInstructionIds: Array.from(ids),
    };
  }
  return {
    instructions: keepOnlyHospitalization(list),
    includedInstructionIds: [HOSPITALIZATION_INSTRUCTION_ID],
  };
}
